(() => {
  function initialise(root) {
    if (root.dataset.initialised) return;
    root.dataset.initialised = 'true';
    const form = root.querySelector('form');
    const button = form.querySelector('button[type=submit]');
    const error = root.querySelector('[data-error]');
    const messages = JSON.parse(root.querySelector('[data-messages]').textContent);
    let submitting = false;
    const rows = () => [...root.querySelectorAll('.btb-product')];
    const showError = text => { error.textContent = text; error.hidden = false; };
    function refresh() {
      const total = rows().reduce((sum, row) => sum + (Number(row.querySelector('[data-variant]').selectedOptions[0]?.dataset.price) || 0) * (Number(row.querySelector('[data-quantity]').value) || 0), 0);
      root.querySelector('[data-total]').textContent = new Intl.NumberFormat('en-GB', { style: 'currency', currency: root.dataset.currency || 'GBP' }).format(total / 100);
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date()).map(p => [p.type,p.value]));
      const ukDay = [parts.year,parts.month,parts.day].join('-');
      const closed = ukDay > '2026-12-20';
      button.disabled = root.dataset.enabled !== 'true' || closed || submitting;
      if (closed) showError(messages.closed);
    }
    form.addEventListener('input', refresh); form.addEventListener('change', refresh);
    form.addEventListener('submit', async event => {
      event.preventDefault(); refresh();
      if (button.disabled || submitting || !form.reportValidity()) return;
      if (Number(form.dataset.existingEveryday) > 0) { showError(messages.separate); return; }
      const properties = { 'Christmas order': '2026' };
      const items = rows().map(row => {
        const option = row.querySelector('[data-variant]').selectedOptions[0];
        return { id: option?.value, quantity: Number(row.querySelector('[data-quantity]').value) || 0, properties, unavailable: !option || option.disabled };
      }).filter(item => item.quantity > 0);
      if (!items.length) { showError(messages.choose); return; }
      if (items.some(item => item.unavailable || !Number.isInteger(item.quantity) || item.quantity > 99)) { showError(messages.check); return; }
      submitting = true; error.hidden = true; refresh(); button.textContent = messages.adding;
      try {
        const response = await fetch(root.dataset.cartUrl + '/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items.map(({unavailable,...item}) => item) }) });
        const result = await response.json();
        if (!response.ok) throw Error(result.description || messages.failed);
        window.location.assign(root.dataset.cartUrl);
      } catch (e) {
        showError((e.message || messages.failed) + ' ' + messages.retry);
        submitting = false; refresh(); button.textContent = messages.add;
      }
    });
    refresh();
  }
  document.querySelectorAll('.btb-order').forEach(initialise);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.btb-order').forEach(initialise));
})();
